<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="error-messages" *ngIf='messageDetails && target === messageDetails.target'>
    <div class='message-{{messageDetails.level}} crsr-pntr' (click)='closeErrorMessage();'>
        <span class="message-text" id="message-text">{{messageDetails.message}}</span>
        <span class="error-close-icon fa fa-times" (click)='closeErrorMessage();'></span>
    </div>
</div>